function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var Transaction = require('./../../../lib/saito/transaction')["default"];
var SLIP_TYPE_P2SH = 10;
var RUSTSCRIPT_IMPORT_KEY = 'rustscript_explorer_import';
var RUSTSCRIPT_MODULE_PATH = '/rustscript';
function getTxMsg(tx) {
  if (tx && typeof tx.returnMessage === 'function') {
    return tx.returnMessage() || {};
  }
  return tx !== null && tx !== void 0 && tx.msg && _typeof(tx.msg) === 'object' ? tx.msg : {};
}
function isP2shInputSlip(slip) {
  var _slip$type;
  if (!slip) {
    return false;
  }
  var type = Number((_slip$type = slip.type) !== null && _slip$type !== void 0 ? _slip$type : slip.slip_type);
  if (type === SLIP_TYPE_P2SH) {
    return true;
  }
  var pk = String(slip.publicKey || slip.public_key || '');
  return pk.length >= 66 && pk.startsWith('00');
}

/**
 * Unlock targets: P2SH marker inputs on spend txs, or script-locked publish outputs.
 */
function collectP2shUnlockTargets(tx) {
  var targets = [];
  var from = Array.isArray(tx === null || tx === void 0 ? void 0 : tx.from) ? tx.from : [];
  for (var i = 0; i < from.length; i++) {
    var _ref, _from$i$index, _from$i, _from$i2, _ref2, _from$i$blockId, _from$i3, _from$i4, _ref3, _from$i$txOrdinal, _from$i5, _from$i6;
    if (!isP2shInputSlip(from[i])) {
      continue;
    }
    var slipIndex = Number((_ref = (_from$i$index = (_from$i = from[i]) === null || _from$i === void 0 ? void 0 : _from$i.index) !== null && _from$i$index !== void 0 ? _from$i$index : (_from$i2 = from[i]) === null || _from$i2 === void 0 ? void 0 : _from$i2.slip_index) !== null && _ref !== void 0 ? _ref : i);
    targets.push({
      id: "input-".concat(i),
      kind: 'input',
      fromIndex: i,
      slipIndex: slipIndex,
      label: "P2SH input \u2014 block ".concat((_ref2 = (_from$i$blockId = (_from$i3 = from[i]) === null || _from$i3 === void 0 ? void 0 : _from$i3.blockId) !== null && _from$i$blockId !== void 0 ? _from$i$blockId : (_from$i4 = from[i]) === null || _from$i4 === void 0 ? void 0 : _from$i4.block_id) !== null && _ref2 !== void 0 ? _ref2 : '—', ", tx ").concat((_ref3 = (_from$i$txOrdinal = (_from$i5 = from[i]) === null || _from$i5 === void 0 ? void 0 : _from$i5.txOrdinal) !== null && _from$i$txOrdinal !== void 0 ? _from$i$txOrdinal : (_from$i6 = from[i]) === null || _from$i6 === void 0 ? void 0 : _from$i6.tx_ordinal) !== null && _ref3 !== void 0 ? _ref3 : '—', ", slip ").concat(slipIndex)
    });
  }
  var txmsg = getTxMsg(tx);
  var isPublishLock = (txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'publish p2sh' || typeof (txmsg === null || txmsg === void 0 ? void 0 : txmsg.access_script) === 'string' && txmsg.access_script.trim().length > 0;
  if (isPublishLock) {
    targets.push({
      id: 'publish-lock',
      kind: 'publish',
      label: 'Script-locked output (publish transaction)'
    });
  }
  return targets;
}
function hasP2shUnlockTargets(tx) {
  return collectP2shUnlockTargets(tx).length > 0;
}
function rawTxToTransaction(app, rawTx) {
  if (!rawTx) {
    return null;
  }
  if (typeof rawTx.serialize_to_web === 'function') {
    return rawTx;
  }
  return new Transaction(undefined, rawTx);
}
function exportTransaction(app, rawTx) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref4$blk = _ref4.blk,
    blk = _ref4$blk === void 0 ? null : _ref4$blk,
    _ref4$block_id = _ref4.block_id,
    block_id = _ref4$block_id === void 0 ? null : _ref4$block_id,
    _ref4$transaction_id = _ref4.transaction_id,
    transaction_id = _ref4$transaction_id === void 0 ? null : _ref4$transaction_id;
  var tx = rawTxToTransaction(app, rawTx);
  if (!tx || typeof tx.serialize_to_web !== 'function') {
    throw new Error('Transaction could not be serialized.');
  }
  if (block_id == null || String(block_id) === '') {
    var _ref5, _blk$id;
    block_id = (_ref5 = (_blk$id = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id !== void 0 ? _blk$id : blk === null || blk === void 0 ? void 0 : blk.block_id) !== null && _ref5 !== void 0 ? _ref5 : null;
  }
  if ((transaction_id == null || String(transaction_id) === '') && blk && tx.signature) {
    var txs = Array.isArray(blk.transactions) ? blk.transactions : [];
    var idx = txs.findIndex(function (candidate) {
      return (candidate === null || candidate === void 0 ? void 0 : candidate.signature) === tx.signature;
    });
    if (idx >= 0) {
      transaction_id = idx;
    }
  }
  if (block_id == null || String(block_id) === '' || transaction_id == null || String(transaction_id) === '') {
    throw new Error('Confirmed block_id and transaction_id are required to export.');
  }
  var json = tx.serialize_to_web(app, {
    block_id: block_id,
    transaction_id: transaction_id,
    update_outputs: true
  });
  var sig = String(tx.signature || 'unknown').replace(/[^\w.-]+/g, '_');
  var filename = "explorer-tx-".concat(sig, ".json");
  var blob = new Blob([json], {
    type: 'application/json'
  });
  var url = URL.createObjectURL(blob);
  var link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
function queueRustscriptImport(app, rawTx, target) {
  var _ref6 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref6$blk = _ref6.blk,
    blk = _ref6$blk === void 0 ? null : _ref6$blk,
    _ref6$block_id = _ref6.block_id,
    block_id = _ref6$block_id === void 0 ? null : _ref6$block_id,
    _ref6$transaction_id = _ref6.transaction_id,
    transaction_id = _ref6$transaction_id === void 0 ? null : _ref6$transaction_id;
  var tx = rawTxToTransaction(app, rawTx);
  if (!tx || typeof tx.serialize_to_web !== 'function') {
    throw new Error('Transaction could not be serialized.');
  }
  if (block_id == null || String(block_id) === '') {
    var _ref7, _blk$id2;
    block_id = (_ref7 = (_blk$id2 = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id2 !== void 0 ? _blk$id2 : blk === null || blk === void 0 ? void 0 : blk.block_id) !== null && _ref7 !== void 0 ? _ref7 : null;
  }
  if ((transaction_id == null || String(transaction_id) === '') && blk && tx.signature) {
    var txs = Array.isArray(blk.transactions) ? blk.transactions : [];
    var idx = txs.findIndex(function (candidate) {
      return (candidate === null || candidate === void 0 ? void 0 : candidate.signature) === tx.signature;
    });
    if (idx >= 0) {
      transaction_id = idx;
    }
  }
  if (block_id == null || String(block_id) === '' || transaction_id == null || String(transaction_id) === '') {
    throw new Error('Confirmed block_id and transaction_id are required to export.');
  }
  var payload = {
    tx: JSON.parse(tx.serialize_to_web(app, {
      block_id: block_id,
      transaction_id: transaction_id,
      update_outputs: true
    })),
    target: target || null
  };
  sessionStorage.setItem(RUSTSCRIPT_IMPORT_KEY, JSON.stringify(payload));
}
function navigateToRustscript() {
  if (typeof navigateWindow === 'function') {
    navigateWindow(RUSTSCRIPT_MODULE_PATH);
    return;
  }
  window.location.href = RUSTSCRIPT_MODULE_PATH;
}
function unlockTransactionInRustscript(app, rawTx, target) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  queueRustscriptImport(app, rawTx, target, options);
  navigateToRustscript();
}
module.exports = {
  SLIP_TYPE_P2SH: SLIP_TYPE_P2SH,
  RUSTSCRIPT_IMPORT_KEY: RUSTSCRIPT_IMPORT_KEY,
  collectP2shUnlockTargets: collectP2shUnlockTargets,
  hasP2shUnlockTargets: hasP2shUnlockTargets,
  exportTransaction: exportTransaction,
  unlockTransactionInRustscript: unlockTransactionInRustscript,
  queueRustscriptImport: queueRustscriptImport,
  navigateToRustscript: navigateToRustscript
};